import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import "./style.css";
import { getTokenInfo } from './../../UseToken';
import Hosts from "../../Hosts"
//import { Redirect } from 'react-router-dom';

import {
    set_language,
	repo_logo_link,
    repo_icons_link,

} from '../../Utils';

import { language } from '../WEBContent/Language';



function logout() {

    if(localStorage.snowCart !== undefined  && localStorage.snowCart !== null) {
        let aux = localStorage.snowCart 
        localStorage.clear(); 
        localStorage.snowCart = aux
      }
      else {
        localStorage.clear();
      }

    //console.log('CAHCE LIMPA');
    //< Redirect to='/simconference' replace />
    //window.location.href = '/chucb-conference-gest';
}
//  <img src="./img/logo-icon.png" alt="Fasquia Importante" className="light-logo-mobile" />
//<img  src="./img/logo.png" alt="Fasquia Importante" className="light-logo " />
const Header = (props) => {
    //let id = getTokenInfo().id;
    let username = getTokenInfo().name;
    let profile = getTokenInfo().profile;
    //let office = getTokenInfo().office.name;

    const [lang, set_lang] = useState('pt');

    const change_lang = (l) => {
        set_language(l)
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {
		
        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
        }

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)


	}, [])

    return (
        <header>
            <nav className="navbar top-navbar navbar-light">
                <div className="navbar-header">
                    <div className="navbar-brand">
                        <a href={Hosts.WEB_BACKOFFICE_URI}>
                            <img src={repo_logo_link("logo-mobile.svg")} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} className="light-logo-mobile img-fluid" />
                            <img src={repo_logo_link("logo.svg")} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} className="light-logo img-fluid" />
                        </a>
                    </div>
                </div>

                <div className="navbar-collapse collapse">
                    <ul className="navbar-nav float-left">
                    </ul>
                    <ul className="navbar-nav float-right">
                        <li className="nav-item d-none">
                            <a href={Hosts.backofficeURL} className="nav-link">
                                <span className="ti-search"></span>
                            </a>
                        </li>  

                        <li className="nav-item d-none">    
                            <button  className={"nav-link " + (lang === 'pt' ? 'assec-current-lang': '')} onClick={() => change_lang('pt')}>PT</button>
                            <span className='nav-link assec-pr-5 assec-pl-5'>|</span>
                            <button  className={"nav-link " + (lang === 'en' ? 'assec-current-lang': '') } onClick={() => change_lang('en')}>EN</button> 
                        </li>                 
                        
                        <li className="nav-item d-none">
                            <a href={Hosts.WEB_BACKOFFICE_URI} className="nav-link">
                                <img alt='' src={repo_icons_link("user.svg")} />
                                <span>{`${username}  `}</span>
                                <p className="name-profile">{`${profile === 'Administrador' ? language[lang].admin : `${profile === 'Revisor' ? language[lang].reviewer : `${profile === 'Autor' ? language[lang].author : `${profile === 'Editor' ? language[lang].publisher : ``}`}`}`}`}</p>
                            </a>
                        </li>
                        
                        { 
                        getTokenInfo().profile !== 'Cliente' ? (
                            <li className="nav-item">
                                <Link className="nav-link" to={{ pathname: (getTokenInfo().profile === 'Gestor de Conteúdos' ? '/webuser_regist' : (getTokenInfo().profile === 'Administrador' ? '/webuser_regist' : (getTokenInfo().profile === 'Instrutor' ? '/instrutor_regist' : ''))), state: { item: {id: getTokenInfo().id}, operation: 'edit' } }} style={{ display: '' }} replace>
                                    <img alt='editar' src={repo_icons_link("perfil.svg")} />
                                    <span>{language[lang].profile}</span>
                                </Link>
                            </li>
                        )
                        :
                            null
                        }
                        { 
                        getTokenInfo().profile === 'Cliente' ? (
                            <li className="nav-item">
                                <Link className="nav-link" to={{ pathname: '/client_regist', state: { item: {id: getTokenInfo().id}, operation: 'edit' } }} style={{ display: '' }} replace>
                                    <img alt='' src={repo_icons_link("user.svg")} />
                                    <span>{username.split(' ')[0]}</span>
                                </Link>
                            </li>
                        )
                        :
                            null
                        }
                        { 
                        getTokenInfo().profile === 'Instrutor' ? (
                            <li className="nav-item">
                                <Link className="nav-link" to={{ pathname: '/instrutor_scale', state: { item: {id: getTokenInfo().id}, operation: 'edit' } }} style={{ display: '' }} replace>
                                    <i className="bi bi-calendar3 me-2"></i>
                                    <span>Escala</span>
                                </Link>
                            </li>
                        )
                        :
                            null
                        }
                        {/* <li className="nav-item">
                            <a href={Hosts.backofficeURL + (getTokenInfo().profile === 'Autor' ? '/autor_regist' : ( getTokenInfo().profile === 'Revisor' ? '/revisor_regist' : (getTokenInfo().profile === 'Editor' ? '/editor_regist' : '') ))} className="nav-link">
                                <img alt='' src={'./img/perfil.svg'} />
                                <span>Perfil</span>
                            </a>
                        </li> */}
                        <li className="nav-item">
                            <a href={Hosts.WEB_BACKOFFICE_URI} onClick={logout} className="nav-link">
                                <img alt='' src={repo_icons_link("sair.svg")} />
                                <span>{language[lang].logout}</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href={Hosts.WEB_SITE_URI} target="_blank" rel="noreferrer" className="nav-link">
                                <img alt='' src={repo_icons_link("website.svg")} />
                                <span>{language[lang].web_page}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
}

export default Header;